
if (import.meta.hot) {
    import.meta.hot.accept();
}

import 'jquery';
import 'owl.carousel';
import 'jquery-ui-bundle';

import App from "@templates/App/App.js";
import _debounce from "lodash/debounce.js";
import Location from "@root/brands/primlynoch/pages/lokalita/Location.js";
import AboutProject from "@root/brands/primlynoch/pages/o-projekte/o-projekte.js";
import VR from "@root/brands/primlynoch/pages/vr/vr.js";

const Web = {
    init: function () {
        $(document).ready(function ($) {
            Location.init();
            AboutProject.init();
            VR.init();
        });

        $(window).resize(_debounce(this.resize, 300))
    },

    resize: function () {
    }
}
App.init();
Web.init();

